module.exports = {
  src: '/img.jpg',
  height: 40,
  width: 40,
  blurDataURL: 'data:image/png;base64,imagedata',
}
